<script>
import base from '@/views/config/addon-cards/templates/base.vue';
import planCommon from './mixin';
import { mapState } from 'vuex';
import { planTypes } from '@/common/constants';
import { get, orderBy } from 'lodash';
import { isZoomMeetingAsAddonCard, isProPlusContext, isEduSchCmpPlusContext } from '@/plans/ZOOM_MEETING/common/utils';
import { planTypesForMeeting } from '@/views/config/addon-cards/index.vue';

export default {
  name: 'TranslationAddon',
  mixins: [base, planCommon],
  for: () => {
    const shouldHide = isZoomMeetingAsAddonCard();
    if (shouldHide) return [];
    if (isProPlusContext) return planTypes.map([planTypes.ZONE_PRO_PLUS]);
    if (isEduSchCmpPlusContext) return false;
    return planTypesForMeeting();
  },
  created() {
    const { amount } = this.lowestPlan;
    this.subtitle = this.$t('billing.common.form_xx_month', [this.$money(amount)]);
  },
  computed: {
    ...mapState({
      planMapFlat: (state) => state.ShoppingCart.planMapFlat,
    }),
    lowestPlan() {
      const list = orderBy(
        this.planMapFlat.filter((p) => p.type === planTypes.TRANSLATION_CAPTIONS),
        ['participants', 'amount'],
        'asc',
      );
      return get(list, [0], {});
    },
  },
};
</script>
